<template>
  <div class="setting-wrap">
    <div class="wrap-title">請求履歴</div>

    <div class="data-table-invoice">
      <div class="data-table-invoice-large">期間</div>
      <div class="data-table-th-bio">プラン名</div>
      <div class="data-table-invoice-large">支払い方法</div>
      <div class="data-table-invoice-large" v-if="userdata.price_display != 'none'">金額</div>
      <div class="data-table-invoice-large">支払い期日</div>
      <!-- <div class="data-table-invoice-mid">ステータス</div> -->
      <!-- <div class="data-table-invoice-detail">請求書</div> -->
    </div>
    <div class="data-table-invoice-tr" v-if="userdata.payment == ''">請求履歴はありません</div>
    <div class="data-table-invoice-tr" v-for="payment in userdata.payment" :key="payment.id" v-else>
      <div class="data-table-invoice-large">{{ payment.period_start | date }}〜{{ payment.period_end | date }}</div>
      <div class="data-table-th-bio">
        <span
          >{{ payment.activate == 12 ? "マネージャープラン" : payment.activate == 13 ? "スタンダードプラン" : payment.activate == 15 ? "プロプラン" : payment.activate >= 17 ? "エンタープライズプラン" : "" }}({{ payment.contract_period }}ヶ月契約)</span
        >
        <span v-if="payment.payment_method == 2">(中途解約)</span>
      </div>
      <div class="data-table-invoice-large">請求書払い</div>
      <div class="data-table-invoice-large" v-if="userdata.price_display != 'none'">{{ payment.contract_price | addComma }}円(税別)</div>
      <div class="data-table-invoice-large">{{ payment.payment_due | date }}</div>
      <!-- 
      <div class="data-table-invoice-mid">
        <i class="el-icon-remove-outline payment_unpaid" v-if="payment.payment_status == 0"></i>
        <i class="el-icon-success payment_paid" v-if="payment.payment_status == 1"></i>
        {{ payment.payment_status == 0 ? "支払予定" : "支払済み" }}
      </div> 
      -->
      <!-- <div class="data-table-invoice-detail"></div> -->
    </div>
  </div>
</template>

<script>
// const root = process.env.VUE_APP_API;

export default {
  name: "paymentHistory",
  props: ["userdata"],
  data() {
    return {
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {},
  methods: {
    
  },
  watch: {},
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    date(val) {
      const datetime = String(val);
      const datetime_parse = datetime.replace(/-/g, "/");
      const date_after = datetime_parse.slice(0, -9);
      return date_after;
    },
  },
};
</script>
